import Link from 'next/link';
import { useQuery } from "@apollo/react-hooks";
import USER from "../../../graphql/queries/user";
import withApollo from "../../../lib/withApollo";
import { getDataFromTree } from "@apollo/react-ssr";
import { getSessionId } from "../../../services/session";
import { useRouter } from "next/router";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var MobileBottomMenu = function MobileBottomMenu() {
  // const [setFavouriteCottages] = useMutation(SET_FAVOURITE_COTTAGES);
  var uuid = getSessionId();
  var router = useRouter(); // useEffect(() => {
  //     setFavouriteCottages({
  //         variables: {
  //             cottageIds: getFavourites()
  //         }
  //     });
  // }, [])

  var _useQuery = useQuery(USER, {
    variables: {
      uuid: uuid
    }
  }),
      loading = _useQuery.loading,
      error = _useQuery.error,
      data = _useQuery.data;

  return /*#__PURE__*/_jsx("footer", {
    className: "mobile-menu",
    children: /*#__PURE__*/_jsxs("div", {
      id: "buttonGroup",
      className: "btn-group selectors",
      role: "group",
      "aria-label": "Basic example",
      children: [/*#__PURE__*/_jsx(Link, {
        href: "/",
        children: /*#__PURE__*/_jsx("button", {
          id: "home",
          type: "button",
          className: "btn btn-secondary ".concat(router.pathname === '/' ? 'button-active' : 'button-inactive'),
          children: /*#__PURE__*/_jsxs("div", {
            className: "selector-holder",
            children: [/*#__PURE__*/_jsx("i", {
              className: "large-tab-icon fas fa-search"
            }), /*#__PURE__*/_jsx("span", {
              children: "Zoeken"
            })]
          })
        })
      }), /*#__PURE__*/_jsx(Link, {
        href: "/favorieten",
        children: /*#__PURE__*/_jsx("button", {
          id: "feed",
          type: "button",
          className: "btn btn-secondary ".concat(router.pathname === '/favorieten' ? 'button-active' : 'button-inactive'),
          children: /*#__PURE__*/_jsxs("div", {
            className: "selector-holder",
            children: [/*#__PURE__*/_jsx("i", {
              className: "large-tab-icon far fa-heart"
            }), data && data.user && data.user.wishlist.productCount > 0 && /*#__PURE__*/_jsx("span", {
              className: "notification-badge",
              children: data.user.wishlist.productCount
            }), /*#__PURE__*/_jsx("span", {
              children: "Bewaard"
            })]
          })
        })
      }), /*#__PURE__*/_jsx(Link, {
        href: "/winkelwagen",
        children: /*#__PURE__*/_jsx("button", {
          id: "cart",
          type: "button",
          className: "btn btn-secondary ".concat(router.pathname === '/winkelwagen' ? 'button-active' : 'button-inactive'),
          children: /*#__PURE__*/_jsxs("div", {
            className: "selector-holder",
            children: [/*#__PURE__*/_jsx("i", {
              className: "large-tab-icon fas fa-shopping-cart"
            }), data && data.user && data.user.cart.productCount > 0 && /*#__PURE__*/_jsx("span", {
              className: "notification-badge",
              children: data.user.cart.productCount
            }), /*#__PURE__*/_jsx("span", {
              children: "Mandje"
            })]
          })
        })
      })]
    })
  });
};

export default withApollo(MobileBottomMenu, {
  getDataFromTree: getDataFromTree
});